import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {Button, TextField} from '@goguardian/based';
import {track} from '../../../track';
import Loading from '_shared/components/loading';
const env = process.env;

import style from './style.scss';

class NoAuth extends React.Component {

  constructor(...args) {
    super(...args);
    this.state = {
      doSave: false,
      params: {
        email: ''
      }
    };
  }

  componentDidMount() {
    track('noAuth', {
      step: '/no-auth',
      productId: this.props.productId
    });
  }

  updateEmail(value) {
    this.setState({
      params: {
        email: value.trim().toLowerCase()
      }
    });
  }

  noAuthClick() {
    this.setState({
      doSave: true
    });
  }

  renderNoAuth() {
    let error;
    const submitDisabled = !this.state.params.email;
    if (this.props.checkNoAuth && !this.props.checkNoAuth.response) {
      error = (<p>We could not validate email/key provided.</p>);
    }
    return (
      <div className={style.noAuthContainer}>
        <h1>Let’s get started…</h1>
        <p>Enter your email to sign up for GoGuardian.</p>
        {error}
        <div className={style.noAuthForm}>
          <TextField
            label="Email"
            className={style.textField}
            onChange={this.updateEmail.bind(this)}
            value={this.state.params.email}
            block/>
          <Button
            onClick={this.noAuthClick.bind(this)}
            disabled={submitDisabled}
            block>
            <span>Sign in with email</span>
          </Button>
        </div>
      </div>
    );
  }

  loaderComplete() {
    this.setState({
      doSave: false
    });
  }

  renderLoading() {
    const noAuthKey = this.props.noAuthKey;
    return (
      <Loading
        actionName="checkNoAuth"
        actionParams={[{email: this.state.params.email, key: noAuthKey}]}
        onComplete={this.loaderComplete.bind(this)}>
        We are creating your account...
      </Loading>
    )
  }

  render() {
    const content = this.state.doSave ? this.renderLoading() : this.renderNoAuth();
    return content;
  }
};


const mapStateToProps = (state) => {
  return {
    productId: state.setProduct,
    noAuthKey: state.noAuthKey,
    checkNoAuth: state.checkNoAuth
  }
};

export default connect(mapStateToProps)(NoAuth);



/** WEBPACK FOOTER **
 ** ./src/app/components/noAuth/index.jsx
 **/